import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
function validateForm(formData) {
    const errors = [];
    // Validate principal
    if (!formData.principal.id?.trim()) {
        errors.push('User ID is required');
    }
    if (!formData.principal.roles || formData.principal.roles.length === 0) {
        errors.push('At least one role is required');
    }
    if (!formData.principal.tenant_id?.trim()) {
        errors.push('Principal tenant ID is required');
    }
    // Validate resource
    if (!formData.resource.kind?.trim()) {
        errors.push('Resource kind is required');
    }
    if (!formData.resource.id?.trim()) {
        errors.push('Resource ID is required');
    }
    if (!formData.resource.tenant_id?.trim()) {
        errors.push('Resource tenant ID is required');
    }
    // Validate action
    if (!formData.action?.trim()) {
        errors.push('Action is required');
    }
    return errors;
}
export default function PolicyTestModal({ onClose, onTest, userTenantId }) {
    const defaultTenantId = userTenantId || 'default';
    // Debug: Log the received tenant ID
    console.log('PolicyTestModal - userTenantId:', userTenantId, 'defaultTenantId:', defaultTenantId);
    const [formData, setFormData] = useState({
        principal: {
            id: 'test-user',
            email: 'test@example.com',
            roles: [
                'user'
            ],
            tenant_id: defaultTenantId,
            scopes: [
                'read'
            ],
            attr: {
                department: 'engineering'
            }
        },
        resource: {
            kind: 'document',
            id: 'test-resource',
            tenant_id: defaultTenantId,
            attr: {
                visibility: 'public',
                owner: 'test-user'
            }
        },
        action: 'read'
    });
    const [validationErrors, setValidationErrors] = useState([]);
    // Update tenant_id when userTenantId prop changes
    useEffect(()=>{
        if (userTenantId) {
            setFormData((prev)=>({
                    ...prev,
                    principal: {
                        ...prev.principal,
                        tenant_id: userTenantId
                    },
                    resource: {
                        ...prev.resource,
                        tenant_id: userTenantId
                    }
                }));
        }
    }, [
        userTenantId
    ]);
    const handleSubmit = (e)=>{
        e.preventDefault();
        const errors = validateForm(formData);
        if (errors.length > 0) {
            setValidationErrors(errors);
            return;
        }
        onTest(formData);
        onClose();
    };
    const handlePrincipalChange = (field, value)=>{
        setFormData((prev)=>({
                ...prev,
                principal: {
                    ...prev.principal,
                    [field]: value
                }
            }));
    };
    const handleResourceChange = (field, value)=>{
        setFormData((prev)=>({
                ...prev,
                resource: {
                    ...prev.resource,
                    [field]: value
                }
            }));
    };
    const handleAttrChange = (type, key, value)=>{
        setFormData((prev)=>({
                ...prev,
                [type]: {
                    ...prev[type],
                    attr: {
                        ...prev[type].attr,
                        [key]: value
                    }
                }
            }));
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "bg-card rounded-lg border border-border shadow-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto",
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text-lg font-semibold text-card-foreground mb-4",
                    children: "Policy Tester"
                }),
                validationErrors.length > 0 && /*#__PURE__*/ _jsxs("div", {
                    className: "bg-destructive/10 border border-destructive/30 rounded-md p-4 mb-4",
                    children: [
                        /*#__PURE__*/ _jsx("h4", {
                            className: "font-semibold text-destructive mb-2",
                            children: "Validation Errors:"
                        }),
                        /*#__PURE__*/ _jsx("ul", {
                            className: "list-disc list-inside text-sm text-destructive space-y-1",
                            children: validationErrors.map((error)=>/*#__PURE__*/ _jsx("li", {
                                    children: error
                                }, error))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("form", {
                    onSubmit: handleSubmit,
                    className: "space-y-6",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-1 lg:grid-cols-2 gap-6",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "border rounded-lg p-4",
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "font-semibold text-card-foreground mb-3",
                                            children: "Principal (User)"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "space-y-3",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            htmlFor: "test-user-id",
                                                            className: "block text-sm font-medium text-muted-foreground mb-1",
                                                            children: "User ID"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            id: "test-user-id",
                                                            type: "text",
                                                            value: formData.principal.id,
                                                            onChange: (e)=>handlePrincipalChange('id', e.target.value),
                                                            className: "w-full border border-border rounded-md px-3 py-2"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            htmlFor: "test-user-email",
                                                            className: "block text-sm font-medium text-muted-foreground mb-1",
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            id: "test-user-email",
                                                            type: "email",
                                                            value: formData.principal.email || '',
                                                            onChange: (e)=>handlePrincipalChange('email', e.target.value),
                                                            className: "w-full border border-border rounded-md px-3 py-2"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            htmlFor: "test-user-roles",
                                                            className: "block text-sm font-medium text-muted-foreground mb-1",
                                                            children: "Roles (comma-separated)"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            id: "test-user-roles",
                                                            type: "text",
                                                            value: formData.principal.roles.join(', '),
                                                            onChange: (e)=>handlePrincipalChange('roles', e.target.value.split(',').map((r)=>r.trim()).filter((r)=>r.length > 0)),
                                                            className: "w-full border border-border rounded-md px-3 py-2",
                                                            placeholder: "user, admin, manager"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            htmlFor: "test-principal-tenant-id",
                                                            className: "block text-sm font-medium text-muted-foreground mb-1",
                                                            children: "Tenant ID"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            id: "test-principal-tenant-id",
                                                            type: "text",
                                                            value: formData.principal.tenant_id,
                                                            onChange: (e)=>handlePrincipalChange('tenant_id', e.target.value),
                                                            className: "w-full border border-border rounded-md px-3 py-2"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            htmlFor: "test-department",
                                                            className: "block text-sm font-medium text-muted-foreground mb-1",
                                                            children: "Department"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            id: "test-department",
                                                            type: "text",
                                                            value: formData.principal.attr?.department || '',
                                                            onChange: (e)=>handleAttrChange('principal', 'department', e.target.value),
                                                            className: "w-full border border-border rounded-md px-3 py-2",
                                                            placeholder: "engineering, sales, hr"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "border rounded-lg p-4",
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "font-semibold text-card-foreground mb-3",
                                            children: "Resource"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "space-y-3",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            htmlFor: "test-resource-kind",
                                                            className: "block text-sm font-medium text-muted-foreground mb-1",
                                                            children: "Resource Kind"
                                                        }),
                                                        /*#__PURE__*/ _jsxs("select", {
                                                            id: "test-resource-kind",
                                                            value: formData.resource.kind,
                                                            onChange: (e)=>handleResourceChange('kind', e.target.value),
                                                            className: "w-full border border-border rounded-md px-3 py-2",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("option", {
                                                                    value: "document",
                                                                    children: "Document"
                                                                }),
                                                                /*#__PURE__*/ _jsx("option", {
                                                                    value: "user",
                                                                    children: "User"
                                                                }),
                                                                /*#__PURE__*/ _jsx("option", {
                                                                    value: "project",
                                                                    children: "Project"
                                                                }),
                                                                /*#__PURE__*/ _jsx("option", {
                                                                    value: "file",
                                                                    children: "File"
                                                                }),
                                                                /*#__PURE__*/ _jsx("option", {
                                                                    value: "api",
                                                                    children: "API"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            htmlFor: "test-resource-id",
                                                            className: "block text-sm font-medium text-muted-foreground mb-1",
                                                            children: "Resource ID"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            id: "test-resource-id",
                                                            type: "text",
                                                            value: formData.resource.id,
                                                            onChange: (e)=>handleResourceChange('id', e.target.value),
                                                            className: "w-full border border-border rounded-md px-3 py-2"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            htmlFor: "test-resource-tenant-id",
                                                            className: "block text-sm font-medium text-muted-foreground mb-1",
                                                            children: "Tenant ID"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            id: "test-resource-tenant-id",
                                                            type: "text",
                                                            value: formData.resource.tenant_id,
                                                            onChange: (e)=>handleResourceChange('tenant_id', e.target.value),
                                                            className: "w-full border border-border rounded-md px-3 py-2"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            htmlFor: "test-visibility",
                                                            className: "block text-sm font-medium text-muted-foreground mb-1",
                                                            children: "Visibility"
                                                        }),
                                                        /*#__PURE__*/ _jsxs("select", {
                                                            id: "test-visibility",
                                                            value: formData.resource.attr?.visibility || 'public',
                                                            onChange: (e)=>handleAttrChange('resource', 'visibility', e.target.value),
                                                            className: "w-full border border-border rounded-md px-3 py-2",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("option", {
                                                                    value: "public",
                                                                    children: "Public"
                                                                }),
                                                                /*#__PURE__*/ _jsx("option", {
                                                                    value: "private",
                                                                    children: "Private"
                                                                }),
                                                                /*#__PURE__*/ _jsx("option", {
                                                                    value: "internal",
                                                                    children: "Internal"
                                                                }),
                                                                /*#__PURE__*/ _jsx("option", {
                                                                    value: "confidential",
                                                                    children: "Confidential"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            htmlFor: "test-owner",
                                                            className: "block text-sm font-medium text-muted-foreground mb-1",
                                                            children: "Owner"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            id: "test-owner",
                                                            type: "text",
                                                            value: formData.resource.attr?.owner || '',
                                                            onChange: (e)=>handleAttrChange('resource', 'owner', e.target.value),
                                                            className: "w-full border border-border rounded-md px-3 py-2"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "border rounded-lg p-4",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "font-semibold text-card-foreground mb-3",
                                    children: "Action"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "grid grid-cols-2 md:grid-cols-4 gap-3",
                                    children: [
                                        'read',
                                        'write',
                                        'delete',
                                        'view',
                                        'edit',
                                        'create',
                                        'admin',
                                        'share'
                                    ].map((action)=>/*#__PURE__*/ _jsxs("label", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    type: "radio",
                                                    name: "action",
                                                    value: action,
                                                    checked: formData.action === action,
                                                    onChange: (e)=>setFormData((prev)=>({
                                                                ...prev,
                                                                action: e.target.value
                                                            })),
                                                    className: "mr-2"
                                                }),
                                                action
                                            ]
                                        }, action))
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex justify-end space-x-3",
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    onClick: onClose,
                                    className: "px-4 py-2 bg-muted text-muted-foreground rounded-md hover:bg-muted/80 transition-colors",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "submit",
                                    className: "px-4 py-2 bg-accent text-primary-foreground rounded-md hover:bg-accent/90 transition-colors",
                                    children: "Run Test"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
